export const POST_MESSAGE_EVENTS = {
    RELOAD_ON_ERROR: 'reloadOnError',
    DEPOSIT_OPEN: 'depositOpen',
    GAME_EXIT: 'gameExit',
};
